import { 
  CQ_ACTION_CODES, 
  CQ_ACTION_NAME 
} from '../../../catalogConstants'
import { getPropKeyByValue } from '../../utils/common';
import { sendCustomTaggingWithParams } from '../../utils/taggingUtils';
import {
  GTM_PRODUCT_OFFERING_TEXT_EMPTY,
  GTM_PRODUCT_PROMOTION_TEXT_EMPTY,
  GTM_PRODUCT_OFFERING_ATTACHMENT_EMPTY,
} from './constants';

const getCatalogTextByTextType = (
  textStructure,
  textType,
  taggingStructure,
) => {
  let text = '';
  if (textStructure) {
    if (textStructure.texts && Array.isArray(textStructure.texts)) {
      const textObj = textStructure.texts.find((element) => {
        return element.typeId === textType;
      });
      if (textObj) {
        ({ text } = textObj);
      }
    }
    if (!text) {
      sendCustomTaggingWithParams(taggingStructure, [
        textType,
        textStructure.id,
      ]);
    }
  }

  return text;
};

export const getProductOfferingTextByTextType = (
  productOffering,
  textType,
  processName,
) => {
  const taggingStructure = {
    ...GTM_PRODUCT_OFFERING_TEXT_EMPTY,
    GAlabel: processName,
  };
  return getCatalogTextByTextType(productOffering, textType, taggingStructure);
};

export const getProductPromotionTextByTextType = (
  productPromotion,
  textType,
  processName,
) => {
  const taggingStructure = {
    ...GTM_PRODUCT_PROMOTION_TEXT_EMPTY,
    GAlabel: processName,
  };
  return getCatalogTextByTextType(productPromotion, textType, taggingStructure);
};

export const getCQActionNameByCode = (cqActionCode) => {
  const keyName = getPropKeyByValue(CQ_ACTION_CODES, cqActionCode);
  return CQ_ACTION_NAME[keyName] || '';
};

export const isNovum = () => {
  let res = false;
  if (typeof window !== 'undefined') {
    res = navigator.userAgent.toLowerCase().indexOf('novum') !== -1;
  }
  return res;
};

const getAttachmentByAttachmentType = (
  productOfferingStructure,
  attachmentType,
  taggingStructure,
) => {
  let attachmentSelected = null;
  if (productOfferingStructure) {
    if (
      productOfferingStructure.attachments &&
      Array.isArray(productOfferingStructure.attachments)
    ) {
      attachmentSelected = productOfferingStructure.attachments.find(
        (element) => {
          return (
            element.attachmentType &&
            element.attachmentType.id === attachmentType
          );
        },
      );
    }
    if (!attachmentSelected) {
      sendCustomTaggingWithParams(taggingStructure, [
        attachmentType,
        productOfferingStructure.productOffering,
      ]);
    }
  }
  return attachmentSelected;
};

export const getProductOfferingAttachmentByAttachmentType = (
  productOffering,
  attachmentType,
  processName,
) => {
  const taggingStructure = {
    ...GTM_PRODUCT_OFFERING_ATTACHMENT_EMPTY,
    GAlabel: processName,
  };
  return getAttachmentByAttachmentType(
    productOffering,
    attachmentType,
    taggingStructure,
  );
};
